import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs/Observable'
import { environment } from '../../../environments/environment'

export interface NbGenre {
  id?: number
  admin_title: string
  title: string
  description: string
  bpm: string
  show_vipgenre: number | boolean | string
  show_wideimage: number | boolean | string
  aspect_ratio: string
  active?: number | boolean | string
  direct_play?: boolean
  image?: string
  thumbnail?: string
  wide_image?: string
  player_image?: string
  basic_img?: string
  wide_img?: string
  spotlight_img?: string
}

export interface NbGenreSelectList {
  id: number
  name: any
}

export interface NbGenreSelectListResponse {
  success: boolean
  genres?: NbGenreSelectList[]
  reason?: string
}

export interface NbGenresResponse {
  success: boolean
  genres: NbGenre[]
}

export interface NbGenreResponse {
  success: boolean
  genre: NbGenre
}

export interface NbGenreSuccessResponse {
  success: boolean
}

@Injectable()
export class GenreService {
  private API_ENDPOINT = `${environment.HOST}/adminapi/genre/`

  constructor(private http: HttpClient) { }

  public getAllGenres(): Observable<NbGenresResponse> {
    return this.http
      .get(`${this.API_ENDPOINT}get`)
      .map((res) => res as NbGenresResponse)
  }

  public getSelectGenres(): Observable<NbGenreSelectListResponse> {
    return this.http
      .get(`${this.API_ENDPOINT}getfulllist`)
      .map((res) => res as NbGenreSelectListResponse)
  }

  public getActiveGenres(): Observable<NbGenresResponse> {
    return this.http
      .get(`${this.API_ENDPOINT}getlist`)
      .map((res) => res as NbGenresResponse)
  }

  public getGenreByID(id: number): Observable<NbGenreResponse> {
    return this.http
      .get(`${this.API_ENDPOINT}getgenre/id/${id}`)
      .map((res) => res as NbGenreResponse)
  }

  public addGenre(genre: NbGenre): Observable<NbGenreSuccessResponse> {
    return this.http
      .post(`${this.API_ENDPOINT}add`, genre)
      .map((res) => res as NbGenreSuccessResponse)
  }

  public saveGenre(genre: NbGenre): Observable<NbGenreSuccessResponse> {
    return this.http
      .post(`${this.API_ENDPOINT}save`, genre)
      .map((res) => res as NbGenreSuccessResponse)
  }

  public deleteGenre(id: number): Observable<NbGenreSuccessResponse> {
    return this.http
      .get(`${this.API_ENDPOINT}delete/id/${id}`)
      .map((res) => res as NbGenreSuccessResponse)
  }
}



// WEBPACK FOOTER //
// /srv/dev/FitRadioAdmin2/src/app/@core/data/genre.service.ts